import { render, staticRenderFns } from "./tongue_twister.vue?vue&type=template&id=48825782&scoped=true&"
import script from "./tongue_twister.vue?vue&type=script&lang=js&"
export * from "./tongue_twister.vue?vue&type=script&lang=js&"
import style0 from "./tongue_twister.vue?vue&type=style&index=0&id=48825782&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48825782",
  null
  
)

export default component.exports